"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Collaboration = void 0;
const falconone_1 = require("../../private/api-services/falconone");
const authData_1 = require("../../private/ephemeral/authData");
class Collaboration {
    constructor() {
        if (!(authData_1.Auth.getUserToken())) {
            throw new Error("Cannot use Collaboration service without authenticated user " +
                "this service is for managing, updating domain's collaboration , " +
                "please use the Authenticator service first");
        }
        this.api = new falconone_1.FalconOne(authData_1.Auth.getUserToken());
    }
    /**
     * @description Get list collaborator by domain
     *
     * @returns {any}
     * @memberof Collaborator
     */
    list(domainUuid) {
        return this.api.get(`collaboration/list/${domainUuid}`);
    }
    /**
     * Invite user to a domain as collaborator
     *
     * @param data iCollaborationInvite
     * @returns
     */
    invite(data) {
        return this.api.post(`collaboration/invite`, data);
    }
    /**
     * Join collaboration using code
     *
     * @param code string
     * @returns
     */
    join(code) {
        return this.api.get(`collaboration/join/${code}`);
    }
    /**
     * leave collaboration by domainUuid
     *
     * @param domainUuid string
     * @returns boolean
     */
    leave(domainUuid) {
        return this.api.post(`collaboration/leave`, { domainUuid });
    }
    /**
     *
     * @param collaborationId number
     * @returns
     */
    remove(collaborationId) {
        return this.api.post(`collaboration/remove`, { collaborationId });
    }
    /**
     *
     * @param collaborationId number
     * @returns
     */
    update(collaborationId, permissions) {
        return this.api.post(`collaboration/update`, { collaborationId, permissions });
    }
}
exports.Collaboration = Collaboration;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY29sbGFib3JhdGlvbi5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9wdWJsaWMvc2VydmljZXMvY29sbGFib3JhdGlvbi50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBQSxvRUFBaUU7QUFDakUsK0RBQXdEO0FBR3hELE1BQWEsYUFBYTtJQUd4QjtRQUNFLElBQUksQ0FBQyxDQUFDLGVBQUksQ0FBQyxZQUFZLEVBQUUsQ0FBQyxFQUFFO1lBQzFCLE1BQU0sSUFBSSxLQUFLLENBQ2IsOERBQThEO2dCQUM1RCxrRUFBa0U7Z0JBQ3BFLDRDQUE0QyxDQUM3QyxDQUFDO1NBQ0g7UUFFRCxJQUFJLENBQUMsR0FBRyxHQUFHLElBQUkscUJBQVMsQ0FBTSxlQUFJLENBQUMsWUFBWSxFQUFFLENBQUMsQ0FBQztJQUNyRCxDQUFDO0lBRUQ7Ozs7O09BS0c7SUFDSSxJQUFJLENBQUMsVUFBa0I7UUFDNUIsT0FBTyxJQUFJLENBQUMsR0FBRyxDQUFDLEdBQUcsQ0FBTSxzQkFBc0IsVUFBVSxFQUFFLENBQUMsQ0FBQztJQUMvRCxDQUFDO0lBRUQ7Ozs7O09BS0c7SUFDSSxNQUFNLENBQUMsSUFBMEI7UUFDdEMsT0FBTyxJQUFJLENBQUMsR0FBRyxDQUFDLElBQUksQ0FBTSxzQkFBc0IsRUFBRSxJQUFJLENBQUMsQ0FBQztJQUMxRCxDQUFDO0lBRUQ7Ozs7O09BS0c7SUFDSSxJQUFJLENBQUMsSUFBWTtRQUN0QixPQUFPLElBQUksQ0FBQyxHQUFHLENBQUMsR0FBRyxDQUFNLHNCQUFzQixJQUFJLEVBQUUsQ0FBRSxDQUFDO0lBQzFELENBQUM7SUFFRDs7Ozs7T0FLRztJQUNJLEtBQUssQ0FBQyxVQUFrQjtRQUM3QixPQUFPLElBQUksQ0FBQyxHQUFHLENBQUMsSUFBSSxDQUFNLHFCQUFxQixFQUFFLEVBQUUsVUFBVSxFQUFFLENBQUMsQ0FBQztJQUNuRSxDQUFDO0lBRUQ7Ozs7T0FJRztJQUNJLE1BQU0sQ0FBQyxlQUF1QjtRQUNuQyxPQUFPLElBQUksQ0FBQyxHQUFHLENBQUMsSUFBSSxDQUFNLHNCQUFzQixFQUFFLEVBQUUsZUFBZSxFQUFFLENBQUMsQ0FBQztJQUN6RSxDQUFDO0lBRUQ7Ozs7T0FJRztJQUNLLE1BQU0sQ0FBQyxlQUF1QixFQUFFLFdBQTJDO1FBQ2pGLE9BQU8sSUFBSSxDQUFDLEdBQUcsQ0FBQyxJQUFJLENBQU0sc0JBQXNCLEVBQUUsRUFBRSxlQUFlLEVBQUUsV0FBVyxFQUFFLENBQUMsQ0FBQztJQUN0RixDQUFDO0NBQ0Y7QUF4RUQsc0NBd0VDIn0=